var map = {
	"./prjcts-oldtyper.png": 8052,
	"./prjcts-pasionargenta.png": 360,
	"./prjcts-retroport.png": 2851,
	"./prjcts-retroport1568x756.png": 9543,
	"./prjcts-spacedementia.png": 9121,
	"./prjcts-xavia.png": 4418,
	"./profilepic.png": 80,
	"./profilepic00.png": 4300,
	"./tst.png": 7209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1078;